import React, { useState } from "react";
import styles from "./index.module.scss";
import useDownloadChartPng, {
	getTopicImage,
} from "../../hooks/useDownloadChartPng";
import useExcelData from "../../hooks/useExcelData";
import TopicDataTable from "../TopicDataTable";
import { chartImageZoomRatio } from "../../data";
import ChartSkeletonLoader from "../ChartSkeletonLoader";

const getImageZoomRatio = (key) => `${100 * (chartImageZoomRatio[key] || 1)}%`;

const DisplayModeSwitch = ({ display, setDisplay }) => (
	<fieldset className={styles.radioGroup}>
		<div className={styles.radioItem}>
			<input
				type="radio"
				id="topic-chart-display"
				name="display"
				value="chart"
				onChange={() => setDisplay("chart")}
				checked={display === "chart"}
			/>
			<label htmlFor="topic-chart-display">圖表呈現</label>
		</div>
		<div className={styles.radioItem}>
			<input
				type="radio"
				id="topic-data-display"
				name="display"
				value="data"
				onChange={() => setDisplay("data")}
				checked={display === "data"}
			/>
			<label htmlFor="topic-data-display">數據呈現</label>
		</div>
	</fieldset>
);

const SampleAndFootnote = ({ sample, footnote, isDataDisplay }) => (
	<div className={styles.sampleAndFootnote}>
		{!isDataDisplay && (
			<div className={styles.sampleInfo}>
				<ul>
					{sample.map((item) => (
						<li key={item}>{item}</li>
					))}
				</ul>
			</div>
		)}
		<div className={styles.footnote}>
			<ol>
				{footnote.map((item) => (
					<li key={item}>{item}</li>
				))}
			</ol>
		</div>
	</div>
);

const DownloadIcon = () => (
	<svg
		width="19"
		height="18"
		viewBox="0 0 19 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>下載</title>
		<g clipPath="url(#clip0_814_2494)">
			<path
				d="M14.5596 15.2506C14.6253 15.3241 14.6758 15.4099 14.7083 15.503C14.7408 15.5961 14.7546 15.6946 14.749 15.7931C14.7433 15.8915 14.7183 15.9878 14.6754 16.0766C14.6325 16.1654 14.5725 16.2448 14.4989 16.3103L13.3094 17.3708C13.1056 17.5726 12.8639 17.7321 12.5982 17.8401C12.3325 17.948 12.0481 18.0024 11.7614 18.0001C11.4639 18.0007 11.1693 17.9425 10.8944 17.829C10.6195 17.7155 10.3697 17.5489 10.1594 17.3386L9.00136 16.3081C8.92778 16.2426 8.86783 16.1632 8.82492 16.0746C8.78201 15.9859 8.75699 15.8897 8.75128 15.7913C8.73975 15.5927 8.80758 15.3977 8.93986 15.2491C9.07213 15.1005 9.25802 15.0105 9.45662 14.999C9.55496 14.9933 9.65345 15.007 9.74649 15.0394C9.83953 15.0717 9.92528 15.1221 9.99886 15.1876L11.0001 16.0831V10.5001C11.0001 10.3012 11.0791 10.1104 11.2198 9.96976C11.3604 9.82911 11.5512 9.75009 11.7501 9.75009C11.949 9.75009 12.1398 9.82911 12.2804 9.96976C12.4211 10.1104 12.5001 10.3012 12.5001 10.5001V16.0838L13.5014 15.1898C13.6498 15.0577 13.8446 14.9898 14.0431 15.0012C14.2415 15.0126 14.4273 15.1023 14.5596 15.2506ZM14.2671 5.52084C14.1383 5.48085 14.0215 5.40957 13.927 5.31337C13.8325 5.21718 13.7633 5.09906 13.7256 4.96959C13.3285 3.69465 12.5174 2.58863 11.4208 1.82665C10.3242 1.06466 9.00476 0.690272 7.67138 0.762756C6.338 0.83524 5.0669 1.35046 4.05936 2.22682C3.05183 3.10319 2.36543 4.29062 2.10886 5.60109C1.8456 6.92635 2.05805 8.302 2.70886 9.48609C1.95019 9.87778 1.33329 10.4973 0.944794 11.2576C0.556301 12.0179 0.415741 12.8808 0.542856 13.7251C0.738345 14.7059 1.26347 15.5904 2.03102 16.2316C2.79857 16.8729 3.76237 17.2322 4.76236 17.2501H6.50011C6.69902 17.2501 6.88978 17.1711 7.03044 17.0304C7.17109 16.8898 7.25011 16.699 7.25011 16.5001C7.25011 16.3012 7.17109 16.1104 7.03044 15.9698C6.88978 15.8291 6.69902 15.7501 6.50011 15.7501H4.76236C4.12183 15.7378 3.50401 15.5106 3.0081 15.105C2.51219 14.6994 2.16697 14.139 2.02786 13.5136C1.94641 12.9763 2.03528 12.4269 2.28197 11.9427C2.52867 11.4584 2.92081 11.0636 3.40336 10.8136C3.7473 10.6235 4.00255 10.3056 4.11386 9.92873C4.22517 9.55185 4.18359 9.14629 3.99811 8.79984C3.70689 8.24443 3.53498 7.63428 3.4934 7.00853C3.45182 6.38278 3.5415 5.75525 3.75667 5.16619C3.97184 4.57713 4.30777 4.03955 4.74289 3.58793C5.17801 3.13631 5.70273 2.78063 6.28338 2.5437C6.86403 2.30677 7.48779 2.19382 8.11465 2.21209C8.74151 2.23037 9.35763 2.37947 9.92349 2.64983C10.4893 2.9202 10.9924 3.30585 11.4005 3.78205C11.8086 4.25825 12.1126 4.81449 12.2931 5.41509C12.4041 5.77712 12.6018 6.10656 12.8691 6.37477C13.1364 6.64299 13.4652 6.84185 13.8269 6.95409C14.8066 7.25221 15.6545 7.87711 16.2294 8.72463C16.8042 9.57214 17.0712 10.5911 16.9859 11.6116C16.9294 12.4051 16.6395 13.1642 16.1526 13.7933C16.0314 13.9511 15.9778 14.1505 16.0036 14.3478C16.0294 14.545 16.1325 14.724 16.2902 14.8452C16.448 14.9665 16.6474 15.0201 16.8447 14.9943C17.0419 14.9684 17.2209 14.8653 17.3421 14.7076C18.0029 13.8461 18.3989 12.8111 18.4821 11.7286C18.5954 10.3679 18.2388 9.00941 17.4718 7.87976C16.7047 6.75011 15.5737 5.91753 14.2671 5.52084Z"
				fill="#5B5B5B"
			/>
		</g>
		<defs>
			<clipPath id="clip0_814_2494">
				<rect width="18" height="18" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);

const DownloadButtons = ({ onClickDownloadPng, onClickDownloadExcel }) => {
	return (
		<div className={styles.downloadButtons}>
			<button
				className={styles.downloadButton}
				type="button"
				onClick={onClickDownloadPng}
			>
				<DownloadIcon />
				<span>下載 PNG</span>
			</button>
			<button
				className={styles.downloadButton}
				type="button"
				onClick={onClickDownloadExcel}
			>
				<DownloadIcon />
				<span>下載 Excel</span>
			</button>
		</div>
	);
};

const TopicImageDisplay = ({ topic }) => {
	const [imageLoaded, setImageLoaded] = useState(false);
	const topicKey = topic.key;

	console.log(getImageZoomRatio(topicKey));

	return (
		<>
			{!imageLoaded && (
				<div className={styles.skeletonContainer}>
					<ChartSkeletonLoader type={topic.chartType || "line"} />
				</div>
			)}
			<img
				className={styles.chartImage}
				src={getTopicImage(topicKey, "svg")}
				alt={topic.title}
				style={{
					width: getImageZoomRatio(topicKey),
					display: imageLoaded ? "block" : "none",
				}}
				onLoad={() => setImageLoaded(true)}
				onError={() => setImageLoaded(true)}
			/>
		</>
	);
};

const TopicChartData = ({ topic }) => {
	const [display, setDisplay] = useState("chart");
	const { canvasRef, downloadPng } = useDownloadChartPng(topic);
	const { excelData, handleDownload: downloadExcel } = useExcelData(topic.key);

	return (
		<div className={styles.container}>
			<h3 className={styles.title}>{topic.title}</h3>
			<div className={styles.chartContainer}>
				<p className={styles.description}>{topic.description}</p>
				<DisplayModeSwitch display={display} setDisplay={setDisplay} />
				{display === "chart" && (
					<TopicImageDisplay key={topic.key} topic={topic} />
				)}

				{display === "data" && <TopicDataTable tableData={excelData} />}
				<SampleAndFootnote
					isDataDisplay={display === "data"}
					sample={topic.sample}
					footnote={topic.footnote}
				/>
				<DownloadButtons
					onClickDownloadPng={downloadPng}
					onClickDownloadExcel={downloadExcel}
				/>
			</div>
			<canvas ref={canvasRef} style={{ display: "none" }} />
		</div>
	);
};

export default TopicChartData;